import { TNewable } from '@ispm/core/interfaces/newable.interface';
import { IWidgetItem } from '@ispm/widgets/interfaces/widget-item.interface';
import { ResolvableService } from '@ispm/core/services/resolvable.service';
import {IAsyncWidgetItem} from "@ispm/widgets/interfaces/async-widget-item.interface";

/**
 * This Decorator provide async/sync widget.
 * need to implement 'widgetLoadDone' function.
 *
 * @param aliases
 * @constructor
 */
export function AsyncWidget(...aliases: string[]): (contextClass: TNewable<IAsyncWidgetItem>) => void {
  return function (contextClass) {
    contextClass['__AsyncWidget'] = true;
    ResolvableService.Register(contextClass, null, ...aliases);
  };
}
